import { route } from 'preact-router';

import { withRedirect } from '@/shared/resetRedirect';

import { validateToken as validateTokenApi } from './api';
import { ENABLE_PASSWORD_RESET_BUTTON, INVALID_TOKEN, SHOW_PASSWORD_RESET_MODAL, TOKEN } from './types';

export const showModal = (showModal, email = '') => ({
  type: SHOW_PASSWORD_RESET_MODAL,
  payload: { showModal, email },
});

export const enableSubmit = (submitEnabled) => ({
  type: ENABLE_PASSWORD_RESET_BUTTON,
  payload: { submitEnabled },
});

export const setToken = (token) => ({
  type: TOKEN,
  payload: { token },
});

export const setInvalidToken = (invalidToken) => ({
  type: INVALID_TOKEN,
  payload: { invalidToken },
});

/**
 * `redirect` is where the visitor was before they asked for the email, and it rides along on every
 * hop from here — including the expired-token one, so that re-requesting a link from the modal that
 * opens there does not lose the destination they started with.
 */
export const validateToken = (token, redirect) => async (dispatch) => {
  try {
    dispatch(setToken(token));
    const { isValid } = await validateTokenApi(token);
    if (!isValid) {
      dispatch(showModal(true));
      route(withRedirect('/login', redirect), true);
    } else {
      route(withRedirect('/passwordReset', redirect));
    }
    dispatch(setInvalidToken(!isValid));
  } catch (err) {
    console.error('Error while validating token', err);
    dispatch(setInvalidToken(false));
  }
};
